var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoundArrowRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 60,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "inherit",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,60 C16.569,60 30,46.569 30,30 C30,13.431 16.569,0 0,0 L0,60 Z",
    stroke: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1 18 24 18 24 42 1 42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2,34.8 C15.6,35.2 15.6,35.8 15.2,36.2 C14.8,36.6 14.1,36.6 13.7,36.2 L9.1,31.9 C8.3,31.1 8.3,29.9 9.1,29.1 L13.7,24.8 C14.1,24.4 14.8,24.4 15.2,24.8 C15.6,25.2 15.6,25.8 15.2,26.2 L10.6,30.5 L15.2,34.8 L15.2,34.8 Z",
    fill: "#FFFFFF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundArrowRight);
export default __webpack_public_path__ + "static/media/roundArrowRight.736231cc36c23a061ff0a41978aabd2d.svg";
export { ForwardRef as ReactComponent };